import MaskedInput from 'antd-mask-input'
import type { FC } from 'react'

type Props = { mask: string }

export const MaskInput: FC<Props> = ({ mask, ...otherProps }) => (
  <MaskedInput mask={mask} {...otherProps} />
)
